import { combineReducers } from 'redux';
import { BLOCKS_UPDATED } from 'news/actions/edito';
import { INITIAL_DATA_LOAD_SUCCESS } from 'news/actions';

const blocks = (state = [], action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
    case BLOCKS_UPDATED:
      return action.blocks;
    default:
      return state;
  }
};

export default combineReducers({
  blocks,
});

export const getBlocks = state => state.edito.blocks;



// WEBPACK FOOTER //
// ./src/modules/news/reducers/edito.js